module.exports = __webpack_public_path__ + "img/step-1.6348b6b5.jpg";